export default __webpack_public_path__ + "static/media/3d71e164da1d1c6a.85cffe28cf8d273cf4cd95fa36b0af96.svg";